document.addEventListener("DOMContentLoaded", () => {
  $(document).on("click", "#counter-regular-scan-qr-code", function(e){
    $(":focus").blur();

    showModal("Scan Label")
    $('.modal-body').html(setCounterRegularModal())
    counterRegularScan()
  })
})